// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroller {
  scrollbar-color: auto;
}`, "",{"version":3,"sources":["webpack://./res/stylesheets/main.scss"],"names":[],"mappings":"AAGA;EACE,qBAAA;AAFF","sourcesContent":["// Overriding main styling\n\n// Remove scrollbar\n.scroller {\n  scrollbar-color: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
